import { render } from "./Quotes.vue?vue&type=template&id=c5369b2c"
import script from "./Quotes.vue?vue&type=script&lang=js"
export * from "./Quotes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__